
import * as React from "react";

const BillingiconSvg = ({ pathNames }) => {
  const isActive = pathNames === "/home/billing";
  const strokeColor = isActive ? "#ffffff" : "#667085";

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={20}
      height={20}
      viewBox="0 0 20 20"
      fill="none"
    >
      <g clipPath="url(#clip0_7284_47613)">
        <path
          d="M3.33329 18.3334H16.6666C17.1087 18.3334 17.5326 18.1578 17.8451 17.8453C18.1577 17.5327 18.3333 17.1088 18.3333 16.6667V3.33341C18.3333 2.89139 18.1577 2.46746 17.8451 2.1549C17.5326 1.84234 17.1087 1.66675 16.6666 1.66675H6.66663C6.2246 1.66675 5.80068 1.84234 5.48811 2.1549C5.17555 2.46746 4.99996 2.89139 4.99996 3.33341V16.6667C4.99996 17.1088 4.82436 17.5327 4.5118 17.8453C4.19924 18.1578 3.77532 18.3334 3.33329 18.3334ZM3.33329 18.3334C2.89127 18.3334 2.46734 18.1578 2.15478 17.8453C1.84222 17.5327 1.66663 17.1088 1.66663 16.6667V9.16675C1.66663 8.25008 2.41663 7.50008 3.33329 7.50008H4.99996"
          stroke={strokeColor}
          strokeWidth={2}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M15 11.6667H8.33337"
          stroke={strokeColor}
          strokeWidth={2}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12.5 15H8.33337"
          stroke={strokeColor}
          strokeWidth={2}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.33337 5H15V8.33333H8.33337V5Z"
          stroke={strokeColor}
          strokeWidth={2}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_7284_47613">
          <rect width={20} height={20} fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default BillingiconSvg;
